import Vue from 'vue'
import * as Config from "../config";
import Cookies from "js-cookie";
import Vuex from 'vuex'
import axios from 'axios'


Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    me: [],
    me_user: [],
    main_account: {},
    id_room_user: null,
  },
  mutations: {
    LOGIN(state, data) {
      state.me = data.data;
      state.me_user = data.data;
      Cookies.set("access_token", data.data.access_token.token);
      Cookies.set("factor", data.data.two_factor_enabled);
    },
    USER(state, data) {
      state.me_user = data.data;
    },
    LOGOUT_OK(state) {
      Cookies.remove("access_token");
      Cookies.remove("user_name");
      Cookies.remove("picture");
      Cookies.remove("factor")
      state.me = [];
      Cookies.remove("id")
    },
    DATAUSER(state, data) {
      state.main_account = data.main_account
      state.id_room_user = data.main_account.user.room_id
    }
  },
  actions: {
    login({ commit }, form) {
      console.log(form)
      //commit("LOGIN");

      return new Promise((resolve, reject) => {
        axios
          .post(Config.apiPath + "/auth/login", form)
          .then(response => {
            if (response.data.code === 200) {
              const accessToken = response.data.data.access_token.token;
              const username = response.data.data.full_name;
              const profile = response.data.data.profile_picture;

              const id = response.data.data.id;

              Cookies.set("access_token", accessToken, { expires: 1 });
              Cookies.set("user_name", username)
              Cookies.set("picture", profile)
              Cookies.set("id", id)
              commit("LOGIN", response.data);
              resolve(response.data);
            } else {
              commit("LOGIN_FAIL1");
              console.log(response);
              reject(response.data);
            }
          })
          .catch(error => {
            console.log("LOGIN_FAIL");
            console.log(error);

            console.log(error.response.data.data);
            reject(error);
          });
      });
    },
    logout({ commit }) {
      commit("LOGOUT_OK");
    },
    RegisterUser({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      console.log(form)
      return new Promise((resolve, reject) => {
        axios
          .post(Config.apiPath + "/user/save", form)
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },

    UserbyId({ commit, dispatch }, id) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios
          .get(Config.apiPath + "/user/" + id)
          .then(response => {
            console.log(response)
            commit("USER", response.data);
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UserUpdate({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      console.log(form)
      return new Promise((resolve, reject) => {
        axios
          .put(Config.apiPath + "/user/update/" + form.id, form.params)
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },
    UpdatePicture({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios.patch(Config.apiPath + "/user/change_profile_picture/" + form.id, form.data, { headers: { 'Content-Type': 'multipart/form-data' } })
          .then(response => {
            resolve(response.data);
            console.log(response.data)
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },
    ChangePassword({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios
          .patch(Config.apiPath + "/user/change_password/" + form.id, form.params)
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },

    RecoveryPassword({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios
          .post(Config.apiPath + "/security/recover_password", form)
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },
    VerifyPassToken({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      console.log(form)
      return new Promise((resolve, reject) => {
        axios
          .post(Config.apiPath + "/security/verify_password_token/" + form.id, form.params)
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },

    SetNewPassword({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      console.log(form)
      return new Promise((resolve, reject) => {
        axios
          .put(Config.apiPath + "/security/set_new_password/" + form.id, form.params)
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },
    /* HOME PAGE */
    getHome({ commit, dispatch }) {
      console.log(dispatch)
      console.log(commit)

      return new Promise((resolve, reject) => {
        axios
          .get(Config.apiPath + "/home")
          .then(response => {
            console.log(response)
            commit("DATAUSER", response.data.data);
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // USER BANK

    getBank({ commit, dispatch }, id) {
      console.log(dispatch)
      console.log(commit)

      return new Promise((resolve, reject) => {
        axios
          .get(Config.apiPath + "/user_bank/all?active=1&index=user_id&value=" + id)
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },

    getBankbyId({ commit, dispatch }, id) {
      console.log(dispatch)
      console.log(commit)

      return new Promise((resolve, reject) => {
        axios
          .get(Config.apiPath + "/user_bank/" + id)
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },




    CreateBankAccount({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      console.log(form)
      return new Promise((resolve, reject) => {
        axios
          .post(Config.apiPath + "/user_bank/save", form)
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },

    getCompanyBank({ commit, dispatch }) {
      console.log(dispatch)
      console.log(commit)

      return new Promise((resolve, reject) => {
        axios
          .get(Config.apiPath + "/company_bank/all")
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },

    getCompanyBankbyId({ commit, dispatch }, id) {
      console.log(dispatch)
      console.log(commit)

      return new Promise((resolve, reject) => {
        axios
          .get(Config.apiPath + "/company_bank/" + id)
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },

    //   USER ACCOUNT


    getAccount({ commit, dispatch }, id) {
      console.log(dispatch)
      console.log(commit)

      return new Promise((resolve, reject) => {
        axios
          .get(Config.apiPath + "/user_account/user/" + id + "/all?index=type_user_account_id&value=1")
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getAccountForBalance({ commit, dispatch }, id) {
      console.log(dispatch)
      console.log(commit)

      return new Promise((resolve, reject) => {
        axios
          .get(Config.apiPath + "/user_account/user/" + id + "/all?index=type_user_account_id&value=2")
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getAccountForHistory({ commit, dispatch }, id) {
      console.log(dispatch)
      console.log(commit)

      return new Promise((resolve, reject) => {
        axios
          .get(Config.apiPath + "/user_account/user/" + id + "/all")
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getBalanceAccount({ commit, dispatch }, id) {
      console.log(dispatch)
      console.log(commit)

      return new Promise((resolve, reject) => {
        axios
          .get(Config.apiPath + "/user_account/get_balance/" + id)
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },
    CreateAccount({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      console.log(form)
      return new Promise((resolve, reject) => {
        axios
          .post(Config.apiPath + "/user_account/save", form)
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },


    EarnLostBalance({ commit, dispatch }, id) {
      console.log(dispatch)
      console.log(commit)

      return new Promise((resolve, reject) => {
        axios
          .get(Config.apiPath + "/account_transaction/balance?user_account_id=" + id)
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // INVESMENT

    CreateInvest({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      console.log(form)
      return new Promise((resolve, reject) => {
        axios
          .post(Config.apiPath + "/account_transaction/investment/save", form)
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },

    RetireInvest({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      console.log(form)
      return new Promise((resolve, reject) => {
        axios
          .post(Config.apiPath + "/account_transaction/main/save", form)
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // HISTORY

    getAccountInfo({ commit, dispatch }, id) {
      console.log(dispatch)
      console.log(commit)

      return new Promise((resolve, reject) => {
        axios
          .get(Config.apiPath + "/account_transaction/all?active=1&orderby=id&key=desc&index=user_account_id&value=" + id)
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },

    //  PAYMENT REPORTS
    GetPaymentReportsByUser({ commit, dispatch }, id){
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios
          .get(Config.apiPath + "/payment_report/user/" + id + "/all")
          .then(response => {
            console.log(response)
            resolve(response.data);
           
          })
          .catch(error => {
            reject(error);
          })
      })
    },

    ReportPaytoAccount({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      console.log(form)
      return new Promise((resolve, reject) => {
        axios
          .post(Config.apiPath + "/payment_report/investment/save", form, { headers: { 'Content-Type': 'multipart/form-data' } })
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },

    
    // WITHDRAW FUNDS FROM MAIN ACCOUNT

    Withdrawfunds({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      console.log(form)
      return new Promise((resolve, reject) => {
        axios
          .post(Config.apiPath + "/account_transaction/withdraw/save", form)
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },

    //   Notifications

    getAllNotifications({ commit, dispatch }, form){
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios
          .get(Config.apiPath + "/notification/user/" + form.id + "/all?index=readed&value=0")
          .then(response => {
            console.log(response)
            resolve(response.data);
           
          })
          .catch(error => {
            reject(error);
          })
      })
    },

    changeStatusNotif({ commit, dispatch }, form){
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios
          .put(Config.apiPath + "/notification/change_status/" + form.id + "/" + form.status)
          .then(response => {
            console.log(response)
            resolve(response.data);
           
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    changeAllNotif({ commit, dispatch }, form){
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios
          .put(Config.apiPath + "/notification/change_all_status/" + form.status)
          .then(response => {
            console.log(response)
            resolve(response.data);
           
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    
    //  CHAT

    loadChat_Messages({ commit, dispatch }, form){
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios
          .get(Config.apiPath + "/room/msg/all?active=1&index=room_id&value="+form.room+"&orderby=id&key=desc")
          .then(response => {
            console.log(response)
            resolve(response.data);
           
          })
          .catch(error => {
            reject(error);
          })
      })
    },
    
    new_Message({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios
          .post(Config.apiPath + "/room/msg/save", form)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error.response.data);
          });
      });
    },

    delete_Chat_Message({ commit, dispatch }, form){
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios
          .put(Config.apiPath + "/room/msg/change_status/" + form.id + "/" + form.status)
          .then(response => {
            console.log(response)
            resolve(response.data);
           
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // TWO-FACTOR-AUTH

    Generate2FA({ commit, dispatch }, id) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios
          .post(Config.apiPath + "/security/two_factor_key/generate/" + id)
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },
    SendEmail({ commit, dispatch }, id) {
      console.log(dispatch)
      console.log(commit)
      return new Promise((resolve, reject) => {
        axios
          .post(Config.apiPath + "/security/send_verification_code/" + id)
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },
    Verify2FA({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      console.log(form)
      return new Promise((resolve, reject) => {
        axios
          .post(Config.apiPath + "/security/two_factor_key/verify", form)
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },
    Enable2FA({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      console.log(form)
      return new Promise((resolve, reject) => {
        axios
          .post(Config.apiPath + "/security/two_factor_key/enable/" + form.id, form.params)
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },
    Disable2FA({ commit, dispatch }, form) {
      console.log(dispatch)
      console.log(commit)
      console.log(form)
      return new Promise((resolve, reject) => {
        axios
          .patch(Config.apiPath + "/security/two_factor_key/disable", form.params)
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },
    AllCountry() {

      return new Promise((resolve, reject) => {
        axios
          .get(Config.apiPath + "/country/all")
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },
    AllStates() {

      return new Promise((resolve, reject) => {
        axios
          .get(Config.apiPath + "/states/all")
          .then(response => {
            console.log(response)
            resolve(response.data);

          })
          .catch(error => {
            reject(error);
          });
      });
    },
  },
  modules: {
  }
})
